import { CompactMatchList } from "components/MatchList/Compact/CompactMatchList";
import { selectRecentMatches } from "selectors/Match";
import { EmptyCompactPanelText } from "styles/text";
import { useAppSelector } from "app/hooks";

interface Props {
  amount: number;
  tournamentIds?: string[];
  hoverColor?: string;
}

export const CompactRecentMatches = ({
  amount,
  tournamentIds,
  hoverColor,
}: Props) => {
  const recentMatches = useAppSelector((state) =>
    selectRecentMatches(state, tournamentIds, amount)
  );

  if (recentMatches.length === 0) {
    return <EmptyCompactPanelText>No Recent Matches</EmptyCompactPanelText>;
  }

  return (
    <CompactMatchList
      matches={recentMatches}
      ascending={false}
      hoverColor={hoverColor}
    />
  );
};
